<template>
    <div class="apprentice-simple-card">
        <div class="breadcrumbs">
            <span
                class="breadcrumb-link"
                v-for="(crumb, index) in breadcrumbs"
                :key="index">
                <span
                    class="breadcrumb-title"
                    @click="navigateTo(crumb, index)">
                    <i
                        class="fas fa-home"
                        v-if="index === 0">
                    </i>
                    {{ index !== 0 ? crumb.name : null }}
                </span>
            </span>
        </div>

        <design-2021-apprentice-data-table
            class="presentations-table"
            :fields="fields"
            :show-empty="true"
            :items="tableData">
            <template v-slot:options>
                <b-button
                    class="btn-add-presentation btn-add"
                    variant="primary"
                    @click="openAddPresentationModal">
                    Presentatie toevoegen
                </b-button>
                <b-button
                    class="btn-add-folder btn-add"
                    variant="primary"
                    @click="openAddFolderModal">
                    Map toevoegen
                </b-button>
            </template>
            <template v-slot:cell(type)="data">
                <div class="slide-type">
                    <i
                        class="fas fa-fw text-primary"
                        v-b-tooltip.hover
                        :title="data.item.type === 'folder' ? 'Bestand' : 'Presentatie'"
                        :class="correctIcon(data.item.type)"
                        @click="openPresentationItem(data.item)">
                    </i>
                </div>
            </template>
            <template v-slot:cell(actions)="data">
                <div
                    class="management-actions"
                    v-if="data.item.type === 'folder'">
                    <b-button
                        class="btn-open"
                        v-b-tooltip="'openen'"
                        variant="primary-icon-only"
                        @click="openFolder(data.item)">
                    </b-button>
                    <b-button
                        class="btn-edit"
                        v-b-tooltip="'naam wijzigen'"
                        variant="primary-icon-only"
                        @click="openEditFolderModal(data.item)">
                    </b-button>

                    <b-button
                        class="btn-remove btn-remove-folder"
                        v-b-tooltip="'verwijderen'"
                        variant="danger-icon-only"
                        @click="removeFolder(data.item)">
                    </b-button>
                </div>
                <div
                    class="management-actions"
                    v-else-if="data.item.type === 'presentation'">
                    <b-button
                        class="btn-chalkboard-teacher"
                        v-b-tooltip="'presenteren'"
                        variant="primary-icon-only"
                        @click="showPresentation(data.item)">
                    </b-button>
                    <b-button
                        class="btn-edit"
                        v-b-tooltip="'bewerken'"
                        variant="primary-icon-only"
                        @click="toPresentationEdit(data.item)">
                    </b-button>
                    <b-button
                        class="btn-copy"
                        v-b-tooltip="'kopiëren'"
                        variant="primary-icon-only"
                        @click="copyPresentation(data.item)">
                    </b-button>
                    <b-button
                        class="btn-remove btn-remove-presentation"
                        v-b-tooltip="'verwijderen'"
                        variant="danger-icon-only"
                        @click="removePresentation(data.item)">
                    </b-button>
                </div>
            </template>

            <template #empty="scope">
                <div class="not-found with-header attachments-list">
                    <div class="icon">
                        <i class="fas fa-exclamation-circle"></i>
                    </div>
                    <div class="alert-notice">
                        <!--                        Todo: Translate-->
                        Er zijn geen presentaties gevonden.
                    </div>
                </div>
            </template>
        </design-2021-apprentice-data-table>
        <design-2021-add-presentation-modal-component
            ref="add-presentation-modal"
            :current-folder-id-in="currentFolderId"
            @data-updated="dataUpdated">
        </design-2021-add-presentation-modal-component>
        <design-2021-copy-presentation-modal
            ref="copy-presentation-modal"
            :current-folder-id-in="currentFolderId"
            :top-folders-in="topFolders"
            @data-updated="dataUpdated">
        </design-2021-copy-presentation-modal>
        <design-2021-add-presentation-folder-modal-component
            ref="add-folder-modal"
            :current-folder-id-in="currentFolderId"
            @data-updated="dataUpdated">
        </design-2021-add-presentation-folder-modal-component>
        <design-2021-edit-presentation-folder-modal-component
            ref="edit-folder-modal"
            @data-updated="dataUpdated">
        </design-2021-edit-presentation-folder-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-presentation-index-component',
    props: {
        loosePresentationsIn: {
            type: Array,
        },
        foldersIn: {
            type: Array,
        },
    },
    data() {
        return {
            loosePresentations: this.loosePresentationsIn,
            topFolders: this.foldersIn,
            currentPresentations: this.loosePresentationsIn,
            currentFolders: this.foldersIn,
            currentFolderId: null,
            fields: [
                {
                    key: 'type',
                    label: '',
                    sortable: true,
                },
                {
                    key: 'name',
                    label: this.$t('common.name'),
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
            currentPath: [],
        };
    },
    computed: {
        tableData() {
            let folders = this.currentFolders.map((folder) => {
                folder.type = 'folder';
                return folder;
            });
            let presentations = this.currentPresentations.map((presentation) => {
                presentation.type = 'presentation';
                return presentation;
            });
            return folders.concat(presentations);
        },
        breadcrumbs() {
            let folderstructure = {
                id: null,
                name: this.$authUser.full_name,
                children: this.topFolders,
                presentations: this.loosePresentations,
            };

            return [folderstructure, ...this.currentPath];
        },
    },
    methods: {
        openAddPresentationModal() {
            this.$refs['add-presentation-modal'].show();
        },
        openAddFolderModal() {
            this.$refs['add-folder-modal'].show();
        },
        dataUpdated(data) {
            this.loosePresentations = data.loose_presentations;
            this.topFolders = data.folders;
            this.alert.success();
            if (this.currentFolderId) {
                let currentFolder = this.breadcrumbs[0];
                for (let i = 0; i < this.currentPath.length; i++) {
                    currentFolder = currentFolder.children.find((folder) => folder.id === this.currentPath[i].id);
                }
                this.currentFolders = currentFolder.children;
                this.currentPresentations = currentFolder.presentations;
            } else {
                this.currentFolders = data.folders;
                this.currentPresentations = data.loose_presentations;
            }
        },
        correctIcon(type) {
            switch (type) {
                case 'folder':
                    return 'fa-folder';
                case 'presentation':
                    return 'fa-presentation';
            }
        },
        openFolder(folder) {
            this.currentFolderId = folder.id;
            this.currentPresentations = folder.presentations;
            this.currentFolders = folder.children;
            if (folder.id) {
                this.currentPath.push(folder);
            }
        },
        navigateTo(folder, index) {
            index ? (this.currentPath = this.currentPath.slice(0, index - 1)) : (this.currentPath = []);
            this.openFolder(folder);
        },
        openEditFolderModal(folder) {
            this.$refs['edit-folder-modal'].show(folder);
        },
        removeFolder(folder) {
            this.alert
                .confirm(
                    'Verwijderen',
                    'Weet je zeker dat je deze ' +
                        folder.name +
                        ' wilt verwijderen? alles in de folder wordt mee verwijderd.',
                    'Ja',
                )
                .then((confirm) => {
                    if (confirm) {
                        this.axios.delete(this.routes.presentationFolderDelete(folder.id)).then(
                            (response) => {
                                this.dataUpdated(response.data);
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
        showPresentation(presentation) {
            window.location.href = this.routes.presentationShow(presentation.id);
        },
        toPresentationEdit(presentation) {
            window.location.href = this.routes.presentationEdit(presentation.id);
        },
        copyPresentation(presentation) {
            this.$refs['copy-presentation-modal'].show(presentation);
        },

        removePresentation(presentation) {
            this.alert
                .confirm(
                    this.$t('common.delete'),
                    this.$t('common.remove_with_name', { name: presentation.name }),
                    this.$t('common.delete'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.axios.delete(this.routes.presentationDelete(presentation.id)).then(
                            (response) => {
                                this.dataUpdated(response.data);
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },

        openPresentationItem(presentation) {
            if (presentation.type === 'folder') {
                this.openFolder(presentation);
            } else {
                this.showPresentation(presentation);
            }
        },
    },
};
</script>

<style scoped lang="scss">
.breadcrumbs {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: $grid-gutter-width;
    gap: map-get($grid-gutter-spacing, 'ten');

    .breadcrumb-link {
        &:not(:last-child) {
            .breadcrumb-title {
                &:after {
                    content: '\f054';
                    font-family: 'Font Awesome 5 Pro';
                    color: $primary;
                    font-size: 0.6875rem;
                    padding-left: map-get($grid-gutter-spacing, 'ten');
                }
            }
        }
    }

    .breadcrumb-title {
        color: $primary;
    }
}

.presentations-table {
    ::v-deep table {
        > thead {
            th {
                &:first-child {
                    width: 65px;
                }

                &:last-child {
                    width: 225px;
                }
            }
        }
    }
}

::v-deep .options {
    display: flex;
    column-gap: map-get($grid-gutter-spacing, 'fifteen');
}

.slide-type {
    display: none;
    font-size: 1.3125rem;

    &:hover {
        cursor: pointer;
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .slide-type {
        display: inline-block;
    }

    .presentations-table {
        ::v-deep .options {
            justify-content: flex-end;
        }
    }
}
</style>
